module.exports = __webpack_public_path__ + "assets/img/page3-side-nav-neutral-ba063b97.png";